import {
  API_ERROR,
  DELETE_SUGGESTED_SEARCH,
  FETCH_SUGGESTED_SEARCH,
  FETCH_SUGGESTED_SEARCH_OPTIONS,
} from "../constants/ActionTypes";
import { apiV2, errorHandler } from "./index";
import Swal from "sweetalert2";

export function fetchAvailableOption() {
  return function (dispatch) {
    apiV2.get(`/suggested-searches/options`)
      .then((response) => {
        dispatch({
          type: FETCH_SUGGESTED_SEARCH_OPTIONS,
          payload: response.data.objects,
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function fetchSuggestedSearches() {
  return function (dispatch) {
    apiV2.get(`/suggested-searches`)
      .then((response) => {
        dispatch({
          type: FETCH_SUGGESTED_SEARCH,
          payload: response.data.objects,
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function deleteSuggesteedSearch(suggested_search_id) {
  return function (dispatch) {
    apiV2.delete(`/suggested-searches/${suggested_search_id}`)
      .then((response) => {
        dispatch({
          type: DELETE_SUGGESTED_SEARCH,
          payload: suggested_search_id,
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function addOrEditSuggestedSearch(suggested_search_data) {
  return function (dispatch) {
    const items = typeof suggested_search_data === 'string' ? JSON.parse(suggested_search_data) : suggested_search_data;
    const request = apiV2.post('/suggested-searches', { data: items });

    request
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Suggested Search Updated!",
          timer: 1000,
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}
